import { observer } from 'mobx-react-lite'
import { RejectDraftInReviewDialog } from '@/features/jobs/details/components/RejectDraftInReviewDialog'
import { type RejectDraftInReviewDialogViewModel } from './RejectDraftInReviewDialogViewModel'

export interface RejectDraftInReviewDialogContainerProps {
  vm: RejectDraftInReviewDialogViewModel
}

export const RejectDraftInReviewDialogContainer = observer(
  function RejectDraftInReviewDialogContainer({
    vm,
  }: RejectDraftInReviewDialogContainerProps) {
    return (
      <RejectDraftInReviewDialog
        showing={vm.modal.showing}
        isRejectDraftPending={vm.rejectDraft.pending}
        onClose={vm.modal.close}
        onRejectDraft={vm.rejectDraft}
      />
    )
  },
)
